/* eslint-disable prettier/prettier */
import React from 'react';
import note from '../img/note.png';
import qiita from '../img/qiita.png';
import StudyPlus from '../img/StudyPlus.svg';
import '../Style/Sns.css';

function Sns() {
  const handleXClick = () => {
    window.location.href = 'https://x.com/Liy_SysE';
  };
  const handleGithubClick = () => {
    window.location.href = 'https://github.com/rin0700';
  };
  const handleDiscordClick = () => {
    window.location.href = 'https://discord.gg/bH26vGUx';
  };
  const handleVRChatClick = () => {
    window.location.href =
      'https://vrchat.com/home/user/usr_c08af74f-c1bc-4ba6-b4d2-ba0eeeec7844';
  };
  const handleNoteClick = () => {
    window.location.href = 'https://note.com/rin0700';
  };
  const handleQiitaClick = () => {
    window.location.href = 'https://qiita.com/rin0700';
  };
  const handleStudyPlusClick = () => {
    window.location.href =
      'https://app.studyplus.jp/users/8b5909e6b2304dfb8590dbca5f04fd81';
  };
  const handleKeyDown = (event, handler) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handler();
    }
  };
  return (
    <div>
      <h2 className="textCenter">LINK</h2>
      <ul className="wrapper">
        <li
          className="icon X"
          onClick={handleXClick}
          onKeyDown={(event) => handleKeyDown(event, handleXClick)}
          role="button"
          tabIndex="0"
        >
          <span className="tooltip">X</span>
          <svg
            height="1.5em"
            width="1.5em"
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="X"
          >
            <path d="M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z"></path>
          </svg>
        </li>
        <li
          className="icon Github"
          onClick={handleGithubClick}
          onKeyDown={(event) => handleKeyDown(event, handleGithubClick)}
          role="button"
          tabIndex="0"
        >
          <span className="tooltip">Github</span>
          <svg
            height="1.5em"
            width="1.5em"
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="Github"
          >
            <path d="M10.07031,20.50291a1.00008,1.00008,0,0,0-1.18115-.9834c-1.30908.24024-2.96191.27637-3.40137-.958a5.70754,5.70754,0,0,0-1.83691-2.415,1.20073,1.20073,0,0,1-.1665-.10938,1,1,0,0,0-.93067-.64551H2.54883a.99965.99965,0,0,0-1,.99512c-.00391.81543.811,1.33789,1.1416,1.51465a4.4408,4.4408,0,0,1,.92383,1.35937c.36426,1.02344,1.42285,2.57617,4.46582,2.376.001.03516.00195.06836.00244.09863l.00439.26758a1,1,0,0,0,2,0l-.00488-.31836C10.07715,21.4951,10.07031,21.22068,10.07031,20.50291Zm10.667-15.126c.03174-.125.063-.26367.09034-.41992a6.27792,6.27792,0,0,0-.40821-3.293,1.002,1.002,0,0,0-.61572-.58007c-.356-.12012-1.67041-.35645-4.18408,1.25a13.86918,13.86918,0,0,0-6.354,0C6.76221.751,5.45459.9658,5.10205,1.07908a.99744.99744,0,0,0-.63135.584,6.3003,6.3003,0,0,0-.40332,3.35644c.02442.12793.05078.2461.07813.35449A6.26928,6.26928,0,0,0,2.89014,9.20311a8.42168,8.42168,0,0,0,.04248.92187c.334,4.60254,3.334,5.98438,5.42431,6.459-.04345.125-.083.25878-.11816.40039a1.00023,1.00023,0,0,0,1.94238.47851,1.6784,1.6784,0,0,1,.46778-.87793.99947.99947,0,0,0-.5459-1.74512c-3.4541-.39453-4.95362-1.80175-5.1792-4.89843a6.61076,6.61076,0,0,1-.03369-.73828,4.25769,4.25769,0,0,1,.91943-2.71289,3.022,3.022,0,0,1,.1958-.23145.99988.99988,0,0,0,.188-1.02441,3.3876,3.3876,0,0,1-.15527-.55567A4.09356,4.09356,0,0,1,6.1167,3.06346a7.54263,7.54263,0,0,1,2.415,1.17968,1.00877,1.00877,0,0,0,.82764.13282,11.77716,11.77716,0,0,1,6.17285.001,1.00549,1.00549,0,0,0,.83056-.13769,7.572,7.572,0,0,1,2.40528-1.19043,4.03977,4.03977,0,0,1,.0874,1.57812,3.205,3.205,0,0,1-.16895.60743.9999.9999,0,0,0,.188,1.02441c.07715.08691.1543.18066.22363.26855A4.12186,4.12186,0,0,1,20,9.20311a7.03888,7.03888,0,0,1-.0376.77734c-.22021,3.05566-1.72558,4.46387-5.1958,4.85937a1,1,0,0,0-.54541,1.7461,1.63079,1.63079,0,0,1,.46631.9082,3.06079,3.06079,0,0,1,.09229.81934v2.334C14.77,21.2949,14.77,21.78025,14.77,22.00291a1,1,0,1,0,2,0c0-.2168,0-.69238.00977-1.33984V18.31346a4.8815,4.8815,0,0,0-.15479-1.31153,4.25638,4.25638,0,0,0-.11621-.416,6.51258,6.51258,0,0,0,5.44531-6.42383A8.69677,8.69677,0,0,0,22,9.20311,6.13062,6.13062,0,0,0,20.7373,5.37693Z"></path>
          </svg>
        </li>
        <li
          className="icon Discord"
          onClick={handleDiscordClick}
          onKeyDown={(event) => handleKeyDown(event, handleDiscordClick)}
          role="button"
          tabIndex="0"
        >
          <span className="tooltip">Discord</span>
          <svg
            height="2em"
            width="2em"
            fill="currentColor"
            viewBox="0 0 31 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.82,17.41a3.1,3.1,0,0,0,2.9,3.26,3.1,3.1,0,0,0,2.89-3.26,3.11,3.11,0,0,0-2.89-3.27A3.11,3.11,0,0,0,9.82,17.41Zm3.79,0c0,.68-.41,1.26-.89,1.26s-.9-.58-.9-1.26.41-1.27.9-1.27S13.61,16.72,13.61,17.41Z" />
            <path d="M19.28,14.14a3.11,3.11,0,0,0-2.89,3.27,3.1,3.1,0,0,0,2.89,3.26,3.1,3.1,0,0,0,2.9-3.26A3.11,3.11,0,0,0,19.28,14.14Zm0,4.53c-.48,0-.89-.58-.89-1.26s.41-1.27.89-1.27.9.58.9,1.27S19.77,18.67,19.28,18.67Z" />
            <path d="M26.63,10.53l-.07-.09s0-.07,0-.1a12.15,12.15,0,0,0-6.8-4.15,1,1,0,1,0-.48,1.94,10.19,10.19,0,0,1,5.65,3.39A24.87,24.87,0,0,1,27,21.33a10,10,0,0,1-5,2.52v-.43s0-.05,0-.08a13.48,13.48,0,0,0,3.43-1.95,1,1,0,0,0-1.25-1.57A12.83,12.83,0,0,1,16,22.42a12.83,12.83,0,0,1-8.11-2.6,1,1,0,0,0-1.25,1.57,13.36,13.36,0,0,0,3.41,1.95v.51a10,10,0,0,1-5-2.52,24.87,24.87,0,0,1,2.09-9.81,10.19,10.19,0,0,1,5.65-3.39,1,1,0,0,0-.48-1.94,12.15,12.15,0,0,0-6.8,4.15s0,.07,0,.1l-.07.09c-1.94,4-2.16,7.65-2.37,11.14a1,1,0,0,0,.29.77A12,12,0,0,0,11,26h0a1,1,0,0,0,.7-.29,1,1,0,0,0,.3-.71V24A17.56,17.56,0,0,0,20,24v1a1,1,0,0,0,.3.71A1,1,0,0,0,21,26h0a12,12,0,0,0,7.74-3.51,1,1,0,0,0,.29-.77C28.79,18.18,28.57,14.57,26.63,10.53Z" />
            <path d="M23.49,11.72a1,1,0,0,0-.43-1.35A15.47,15.47,0,0,0,16,8.87a15.47,15.47,0,0,0-7.06,1.5,1,1,0,0,0-.43,1.35,1,1,0,0,0,1.35.42A13.55,13.55,0,0,1,16,10.87a13.55,13.55,0,0,1,6.14,1.27,1,1,0,0,0,.46.12A1,1,0,0,0,23.49,11.72Z"></path>
          </svg>
        </li>
        <li
          className="icon VRChat"
          onClick={handleVRChatClick}
          onKeyDown={(event) => handleKeyDown(event, handleVRChatClick)}
          role="button"
          tabIndex="0"
        >
          <span className="tooltip">VRChat</span>
          <img
            src="https://assets.vrchat.com/www/favicons/safari-pinned-tab.svg"
            alt="VRChat"
            height="26px"
            width="26px"
          />
        </li>
        <li
          className="icon Note"
          onClick={handleNoteClick}
          onKeyDown={(event) => handleKeyDown(event, handleNoteClick)}
          role="button"
          tabIndex="0"
        >
          <span className="tooltip">Note</span>
          <img height="40px" width="40px" src={note} alt="note" />
        </li>
        <li
          className="icon Qiita"
          onClick={handleQiitaClick}
          onKeyDown={(event) => handleKeyDown(event, handleQiitaClick)}
          role="button"
          tabIndex="0"
        >
          <span className="tooltip">Qiita</span>
          <img height="40px" width="40px" src={qiita} alt="qiita" />
        </li>
        <li
          className="icon StudyPlus"
          onClick={handleStudyPlusClick}
          onKeyDown={(event) => handleKeyDown(event, handleStudyPlusClick)}
          role="button"
          tabIndex="0"
        >
          <span className="tooltip">StudyPlus</span>
          <img height="40px" width="40px" src={StudyPlus} alt="StudyPlus" />
        </li>
      </ul>
    </div>
  );
}

export default Sns;
